export const COOKIE_KID = 'ds-kid'
export const COOKIE_TFF = 'ds-tff-enabled'
